import React from 'react';
import { observer } from 'mobx-react-lite';

import { WidgetContactFormMode } from 'widget/entities/config';
import { WidgetTexts } from 'widget/consts/texts';
import type { ISubmissionFormState } from 'widget/types/submissionFormState';

import SubmissionFormContainer from './SubmissionFormContainer';
import SubmissionIntro from './SubmissionIntro';
import ContactFormBlock from './ContactFormBlock';
import ConsentsBlock from './ConsentsBlock';
import SubmitButton from './SubmitButton';

export type SubmissionFormBodyProps = {
  submissionFormStore: ISubmissionFormState;
};

const SubmissionFormBody: React.FC<SubmissionFormBodyProps> = ({
  submissionFormStore
}) => {
  const mode = submissionFormStore.contactFormMode!;
  const showForm =
    submissionFormStore.shouldShowContactForm ||
    submissionFormStore.shouldShowConsents;

  if (!showForm) {
    return null;
  }

  const introTitle = WidgetTexts.submissionForm.title[mode]?.title ?? null;
  const introSubtitle =
    WidgetTexts.submissionForm.title[mode]?.subtitle ?? null;
  const submitButtonLabel =
    WidgetTexts.submissionForm.submitButton[mode] ?? null;

  return (
    <SubmissionFormContainer mode={mode}>
      {mode !== WidgetContactFormMode.disabled && introTitle && (
        <SubmissionIntro
          mode={mode}
          title={introTitle}
          subtitle={introSubtitle}
        />
      )}
      {submissionFormStore.shouldShowContactForm && <ContactFormBlock />}
      {submissionFormStore.shouldShowConsents && <ConsentsBlock />}
      {submitButtonLabel && (
        <SubmitButton
          label={submitButtonLabel}
          disabled={!submissionFormStore.isFormValid}
          loading={submissionFormStore.isSubmitting}
          onClick={submissionFormStore.submit}
        />
      )}
    </SubmissionFormContainer>
  );
};

export default observer(SubmissionFormBody);
